import { callApi, callApiWithData } from './call-api';
import { ShoppingListEntry, mapShoppingListEntryFromApi } from '../models/shopping-list';

export type ShoppingListResponse = {
  entries: ShoppingListEntry[];
  itemCount: number;
};

export const getShoppingList = async (): Promise<ShoppingListResponse> => {
  const response = await callApi('/shopping-list');
  const list = response.shoppingList ?? {};
  return {
    entries: (list.entries ?? []).map(mapShoppingListEntryFromApi),
    itemCount: list.itemCount ?? 0,
  };
};

export const generateShoppingList = async (
  mealPlanId: string,
  mode: 'add' | 'overwrite'
): Promise<ShoppingListResponse> => {
  const response = await callApiWithData('/shopping-list/generate', { mealPlanId, mode }, 'POST');
  const list = response.shoppingList ?? {};
  return {
    entries: (list.entries ?? []).map(mapShoppingListEntryFromApi),
    itemCount: list.itemCount ?? 0,
  };
};

export const addMealToShoppingList = async (mealId: string): Promise<ShoppingListResponse> => {
  const response = await callApiWithData('/shopping-list/add-meal', { mealId }, 'POST');
  const list = response.shoppingList ?? {};
  return {
    entries: (list.entries ?? []).map(mapShoppingListEntryFromApi),
    itemCount: list.itemCount ?? 0,
  };
};

export const updateShoppingListEntry = async (entryId: string, checked: boolean): Promise<void> => {
  await callApiWithData(`/shopping-list-entry/${entryId}`, { checked }, 'PUT');
};

export const addCustomItem = async (name: string): Promise<ShoppingListResponse> => {
  const response = await callApiWithData('/shopping-list/custom-item', { name }, 'POST');
  const list = response.shoppingList ?? {};
  return {
    entries: (list.entries ?? []).map(mapShoppingListEntryFromApi),
    itemCount: list.itemCount ?? 0,
  };
};

export const clearShoppingList = async (): Promise<void> => {
  await callApi('/shopping-list', 'DELETE');
};
